import React from 'react'

import { Table } from 'Components/Table'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'

import LocationRow from './LocationRow'

const LocationsTable = ({
  locations,
  changeSort,
  handleModalArchiveShow,
  handleModalEditShow,
}) => {
  return (
    <Table>
      <thead>
        <Tr>
          <Th className="sortable" onClick={() => changeSort('name')}>
            Name
          </Th>
          <Th className="sortable" onClick={() => changeSort('label')}>
            Label
          </Th>
          <Th className="sortable" onClick={() => changeSort('type')}>
            Type
          </Th>
          <Th className="sortable" onClick={() => changeSort('momentsMorning')}>
            Morning
          </Th>
          <Th className="sortable" onClick={() => changeSort('momentsLunch')}>
            Lunch
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('momentsAfternoon')}
          >
            Afternoon
          </Th>
          <Th className="sortable" onClick={() => changeSort('isSheltered')}>
            Sheltered?
          </Th>
          <Th className="sortable" onClick={() => changeSort('isEvent')}>
            Event?
          </Th>
          <Th className="sortable" onClick={() => changeSort('requirePermit')}>
            Needs Permit
          </Th>
          <Th className="align-right sortable">Actions</Th>
        </Tr>
      </thead>
      <tbody>
        {locations.map(location => (
          <LocationRow
            location={location}
            handleModalArchiveShow={handleModalArchiveShow}
            handleModalEditShow={handleModalEditShow}
          />
        ))}
      </tbody>
    </Table>
  )
}

export default LocationsTable



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Locations/Components/LocationsTable.jsx